import React from 'react';
import PropTypes from 'prop-types';

import {Divider, Typography} from '@ui';

const SegmentHeader = ({children, buttons, dividing = true}) => {
    return (
        <>
            <Typography
                component='h3'
                variant='h6'
                className='segmentHeader'
            >
                {children && (
                    <span className='segmentHeader'>
                        {children}
                    </span>
                )}
                <div className='segmentHeader__buttons'>{buttons}</div>
            </Typography>

            {dividing && <Divider sx={{marginTop: 0.5}}/>}
        </>
    );
};

SegmentHeader.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string,
    ]),
    buttons: PropTypes.node,
    dividing: PropTypes.bool,
};

export default SegmentHeader;
